import React from 'react'
import CompactList from '../compact-list'
import DetailedList from '../detailed-list'
import ListToggle from '../list-toggle'


export default function AllProducts ({ browser , products, session, user, onSwitchListView }) {

  const { aggregateData, isLoadingAggregated } = products
  const { language, listView } = session
  const { isRetailMode } = user
  const { isOnline } = browser
  const { warehouseCode } = user
  const showDetailed = aggregateData.length === 1 || listView === 'detailed'
  
  // Show loading state when aggregated products are being fetched
  if (isLoadingAggregated) {
    return (
      <div style={{ display: 'flex', backgroundColor: '#F7F7F9' }}>
        <main className='atlas-products'>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '60px 20px',
            fontSize: '16px',
            color: '#666'
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '15px'
            }}>
              <div className="spinner-border" role="status" style={{
                width: '3rem',
                height: '3rem',
                borderWidth: '0.3em'
              }}>
                <span className="sr-only">Loading...</span>
              </div>
              <div>Loading products...</div>
            </div>
          </div>
        </main>
      </div>
    )
  }
  
  if (aggregateData.length === 0) {
    return (
      <div style={{ display: 'flex', backgroundColor: '#F7F7F9' }}>
        <main className='atlas-products'>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '60px 20px',
            fontSize: '16px',
            color: '#666'
          }}>
            <div>No products found in this category.</div>
          </div>
        </main>
      </div>
    )
  }
  
  const mappedProducts = aggregateData.map((product) => {
          return {
            attributes: {
              ...product
            },
            type : 'product',
            _id: product._id
          }})


  return (
    <div style={{ display: 'flex', backgroundColor: '#F7F7F9' }}>
    <main className='atlas-products'>
      <ListToggle
        listView={listView}
        onSwitchListView={onSwitchListView}
      />
      <div style={{ marginTop: '2rem' }}>
        {
          showDetailed &&
          <DetailedList
            session={session}
            isOnline={isOnline}
            isRetailMode={isRetailMode}
            language={language}
            products={mappedProducts}
            userRoles={user.roles}
            warehouseCode={warehouseCode}
          />
        }
        {
          !showDetailed &&
          <CompactList
            session={session}
            isOnline={isOnline}
            isRetailMode={isRetailMode}
            language={language}
            products={mappedProducts}
            userRoles={user.roles}
            warehouseCode={warehouseCode}
          />
        }

      </div>
    </main>
  </div>
  )
}
